import { callApi } from "../../libs"

const getPreBookingList = async () => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/pre-bookings/by-status`
        const method = 'get'
        try {
            const response = await callApi(method, url, null, null)
            // console.log(response)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default getPreBookingList